export default "dist/images/components-button-controls-plain.c53a21e.png";